const en = {
  // Greetings & Date
  goodMorning: 'Good Morning',
  goodAfternoon: 'Good Afternoon',
  goodEvening: 'Good Evening',
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

  // Navigation
  dashboard: 'Dashboard',
  sales: 'Sales',
  purchases: 'Purchases',
  expenses: 'Expenses',
  inventory: 'Stock',
  setup: 'Business Details',
  settings: 'Settings',

  // Common actions
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  confirmDelete: 'Are you sure you want to delete this record?',
  back: 'Back',
  add: 'Add',
  close: 'Close',
  customer: 'Customer',
  supplier: 'Supplier',
  amount: 'Amount',
  actions: 'Actions',
  category: 'Category',
  product: 'Product',
  qty: 'Qty',
  description: 'Description',
  balance: 'Balance',
  type: 'Type',
  reference: 'Reference',


  // Ribbon
  welcome: 'Welcome!',
  setBusinessName: 'Set your business name',
  autoCalculatedEditable: 'auto-calculated, editable',

  // Settings screen
  businessName: 'Business Name',
  yourBusinessName: 'Your business name',
  language: 'Language',
  english: 'English',
  swahili: 'Swahili',
  currency: 'Currency',
  darkMode: 'Dark Mode',
  darkModeSub: 'Toggle dark theme (UI only)',
  fontSize: 'Font Size',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  appVersion: 'App Version',

  // Dashboard
  businessOverview: 'Business Overview',
  today: 'Today',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  thisWeek: 'Week',
  thisMonth: 'Month',
  thisYear: 'Year',
  revenue: 'Revenue',
  profit: 'Profit',
  loss: 'Loss',
  totalSales: 'Total Sales',
  totalExpenses: 'Total Expenses',
  totalPurchases: 'Total Purchases',
  productPurchases: 'Product Purchases (Stock)',
  productRevenue: 'Product Revenue',
  topProducts: 'Top 3 Products',
  insights: 'Insights',
  recentActivity: 'Recent Activity',
  noSalesRecordedYet: 'No sales recorded yet',
  noActivityRecordedYet: 'No activity recorded yet',
  stockStatus: 'Stock Status',
  itemsInStock: 'Items in Stock',
  lowStock: 'Low Stock Items',

  // Sales
  salesSummary: 'Sales Summary',
  recordNewSale: 'Record New Sale',
  viewDetailedSalesReport: 'Detailed Report',
  detailedSalesReport: 'Detailed Sales Transactions Report',
  totalRevenue: 'Total Revenue',
  totalItemsSold: 'Total Items Sold',
  salesPerProduct: 'Sales per Product',
  salesList: 'Sales List',
  selectProduct: 'Select Product',
  selectCustomer: 'Select Customer',
  productName: 'Product Name',
  quantity: 'Quantity',
  sellingPrice: 'Selling Price',
  customerName: 'Customer Name',
  date: 'Date',
  totalCost: 'Total Cost',
  pleaseRegisterProducts: 'Please register products in Setup first',

  // Purchases
  purchasesSummary: 'Purchases Summary',
  registerPurchase: 'Register New Purchase',
  recordingSection: 'Recording Section',
  purchasesReports: 'Purchase Reports',
  viewDetailedReport: 'View Detailed Purchases Report',
  detailedPurchaseReport: 'Detailed Purchase Transactions Report',
  fromDate: 'From Date',
  toDate: 'To Date',
  totalSpend: 'Total Spend',
  totalItems: 'Total Items',
  purchasesList: 'Purchase List',
  totalCostPerProduct: 'Total Cost per Product',
  unitPrice: 'Unit Price',
  downloadPDF: 'Download PDF Report',
  downloadExcel: 'Download Excel',
  downloadCSV: 'Download CSV',

  // Expenses
  expensesSummary: 'Expenses Summary',
  recordNewExpense: 'Record New Expense',
  viewDetailedExpensesReport: 'Detailed Report',
  detailedExpensesReport: 'Detailed Expenses Transactions Report',
  expenseName: 'Expense Name',
  totalExpense: 'Total Expense',
  expensesPerCategory: 'Expenses per Category',
  expensesList: 'Expenses List',
  selectCategory: 'Select Expense Type',

  // Stock / Inventory
  stockLevels: 'Stock Levels',
  currentStock: 'Current Stock',
  openingStock: 'Opening Stock',
  stockIn: 'Stock In',
  stockOut: 'Stock Out',
  openingStockQty: 'Opening Stock Quantity',
  openingStockValue: 'Opening Stock Value',
  minStockAlert: 'Minimum Stock Alert',
  stockAlertLevel: 'Stock Alert Level',
  quantityInStock: 'Quantity in Stock',
  totalStockValue: 'Total Stock Value (TSh)',
  lowStockThreshold: 'Low Stock Threshold',
  addNewStock: 'Add New Stock',
  stockChart: 'Stock Chart',
  healthChart: 'Stock Health Chart',
  healthyProducts: 'Healthy Products',
  lowStockProducts: 'Low Stock Products',
  totalProducts: 'Total Products',
  topLowStock: 'Top 10 Lowest Stock Products',
  stockAlerts: 'Products Needing Restock',
  allStockGood: 'All products are in good condition',
  currentStockLevel: 'Current Stock Level',

  // Setup
  products: 'Products',
  expenseCategories: 'Expense Names',
  suppliers: 'Suppliers',
  productList: 'List of Registered Products',
  expenseList: 'List of Expense Types',
  registerNewProduct: 'Register New Product',
  registerExpenseType: 'Register Expense Type',
  productRegistration: 'Product Registration',
  expenseRegistration: 'Expense Registration',
  price: 'Price',
  cost: 'Cost',
  noProductsYet: 'No products registered yet. Add your first product above.',
  noExpenseCategoriesYet: 'No expense categories yet.',
  noSuppliersYet: 'No suppliers added yet.',
  supplierName: 'Supplier Name',
  contactOptional: 'Contact (optional)',
  phoneOrEmail: 'Phone or email',
  addSupplier: 'Add Supplier',
  editSupplier: 'Edit Supplier',
  addCategory: 'Add Category',
  addProduct: 'Add Product',
  expenseType: 'Expense Type',
  expenseCategoryPlaceholder: 'e.g. Rent, Transport, Salaries',

  // Sales screen
  newSale: 'New Sale',
  sell: 'Sell',
  salesReports: 'Sales Reports',
  unitsSold: 'Units Sold',
  salesCount: 'No. of Transactions',
  salesByProduct: 'Sales by Product',
  topSellingProducts: 'Top-Selling Products',
  lowSellingProducts: 'Low-Selling Products',
  units: 'units',
  recentSales: 'Recent Sales',
  clientsServed: 'Clients Served',
  avgPerJob: 'Avg / Job',
  incomeByService: 'Income by Service',
  topServices: 'Top Services',
  byRevenue: 'By Revenue',
  byProfit: 'By Profit',
  recordServicesToSeeRankings: 'Record services to see rankings',
  clientInsights: 'Client Insights',
  whoComesBackMost: 'Who comes back most & what they book',
  startTrackingClients: 'Start tracking your clients',
  startTrackingClientsDesc: "When you record a service, add the client's name. This section will show you who visits most, how much they spend, and which services they prefer.",
  visitSingular: 'visit',
  visitPlural: 'visits',
  prefers: 'prefers',
  repeatClient: 'Repeat',
  invoiceManagement: 'Invoice Management',
  invoiceManagementProducts: 'Invoices',
  invoiceManagementServices: 'Invoices',
  listProformaInvoices: 'List Proforma Invoices',
  listIssuedInvoices: 'List Issued Invoices',
  proformaInvoices: 'Proforma Invoices',
  issuedInvoices: 'Issued Invoices',
  noProformaInvoices: 'No proforma invoices yet',
  noIssuedInvoices: 'No issued invoices yet',
  invoices: 'invoices',


  // Purchases screen
  addPurchase: 'Record Purchase',
  purchaseReports: 'Purchase Reports',
  itemsBought: 'Items Bought',
  orders: 'Orders',
  purchasesCount: 'No. of Transactions',
  purchasesByProduct: 'Purchases by Product',
  supplierBreakdown: 'Supplier Breakdown',
  highCostItems: 'High-Cost Items',
  recentPurchases: 'Recent Purchases',

  // Expenses screen
  addExpense: 'Add Expense',
  expenseReports: 'Expense Reports',
  expenseTitle: 'Expense title',
  notesOptional: 'Notes (optional)',
  noOfExpenses: 'expense records',
  expensesByCategory: 'Expenses by Category',
  biggestExpenses: 'Biggest Expenses',
  recentExpenses: 'Recent Expenses',

  // Stock screen
  stockOverview: 'Stock Overview',
  items: 'items',
  addedThisWeek: 'Added This Week',
  soldThisWeek: 'Sold This Week',
  minLabel: 'Min',
  leftLabel: 'left',
  inStock: 'In Stock',
  stockLow: 'Low Stock',
  fastMovingItems: 'Fast-Moving Items',
  topPerforming: 'Top Performing Products',
  unitCost: 'Unit Cost',
  productHistory: 'Product History',
  noHistoryAvailable: 'No history available',
  totalPurchased: 'Total Purchased',
  totalSold: 'Total Sold',
  inLabel: 'In',
  outLabel: 'Out',
  soldLabel: 'sold',


  // Setup form labels
  editProduct: 'Edit Product',
  editCategory: 'Edit Category',
  addExpenseCategory: 'Add Expense Category',
  categoryName: 'Category Name',
  noContactInfo: 'No contact info',
  priceOptional: 'Price (optional)',
  costOptional: 'Cost (optional)',
  totalValue: 'Total value',
  valueLabel: 'Value',
  alertLabel: 'Alert',

  // Reports shared
  startDate: 'Start Date',
  endDate: 'End Date',
  noDataForPeriod: 'No data for selected period',
  titleLabel: 'Title',

  pleaseAddExpenseCategories: 'Please add expense categories in Setup',

  // Purchase / Supplier type
  supplierType: 'Seller (Optional)',
  registeredSupplier: 'Registered Name',
  otherSupplier: 'Unregistered',
  enterSupplierName: 'Enter seller name',
  purchaseCost: 'Purchase Cost (TSh)',
  costPerSale: 'Cost / Purchase Cost',
  profitPerSale: 'Profit',

  // Customers
  customers: 'Customers',
  addCustomer: 'Add Customer',
  editCustomer: 'Edit Customer',
  noCustomersYet: 'No customers added yet.',
  phoneOptional: 'Phone (optional)',
  customerType: 'Customer Type',
  walkIn: 'Walk-in',
  registered: 'Registered',
  enterCustomerName: 'Enter customer name',

  // Payment
  paymentMethod: 'Payment Method',
  cash: 'Cash',
  bank: 'Bank',
  mobileMoney: 'Mobile Money',
  credit: 'Credit (Loan)',
  paymentStatus: 'Payment Status',
  paid: 'Paid',
  unpaid: 'Unpaid (Credit)',

  // Reports filters
  filterByProduct: 'Filter by Product',
  filterByPayment: 'Filter by Payment',
  filterByCustomer: 'Filter by Customer',
  allProducts: 'All Products',
  allPayments: 'All Payments',
  allCustomers: 'All Customers',
  creditSales: 'Outstanding (Owed to You)',

  // Debt / Loan payment
  receiveDebtPayment: 'Receive Debt Payment',
  payLoan: 'Pay Loan',
  selectDebt: 'Select Outstanding Debt',
  selectLoan: 'Select Outstanding Loan',
  markAsPaid: 'Mark as Paid',
  debtPaymentSuccess: 'Payment recorded successfully',

  // Expenses tab UI (updated)
  recordExpense: 'Record Expense',
  viewExpenseReports: 'View Expense Reports',
  expenseTrend: 'Expense Trend',

  // Purchases tab UI (updated)
  recordPurchase: 'Record Purchase',
  viewPurchasesReports: 'View Purchases Reports',
  purchaseTrend: 'Purchase Trend',
  topPurchasedProducts: 'Top Purchased Products',
  lowPurchasedProducts: 'Least Purchased Products',

  // Sales tab UI (updated)
  recordSale: 'Record Sale',
  viewSalesReports: 'Sales Reports',
  custom: 'Custom',
  annualPerformance: 'Annual Performance',
  salesTrend: 'Sales Trend',
  productPerformance: 'Product Performance',
  salesOverview: 'Sales Overview',
  salesOverviewSub: 'Muhtasari wa Mauzo',
  annualPerformanceSub: 'Utendaji wa Mwaka',
  selectYear: 'Select Year',
  annualTotal: 'Annual Total',
  overallProductPerformance: 'Overall Annual Product Performance',
  overallProductSub: 'Revenue per product',
  lowestSellersRevenue: 'Top 5 Lowest Revenue',
  lowestSellersRevenueSub: 'Lowest earning products this year',

  // Misc
  comingSoon: 'Coming Soon',
  status: 'Status',
  costPerItem: 'Cost per Item',

  // Account Balances (Dashboard)
  accountBalances: 'Account Balances',
  tapToView: 'Tap to view',

  // Dashboard section headers
  businessSummary: 'Business Summary',
  accrualBasis: 'Accrual basis (paid + credit)',
  cashPosition: 'Cashflow Position',
  cashPositionNote: 'Real money only',
  debts: 'Debts',
  netCashflow: 'Total Cashflow',
  paidLabel: 'Paid',
  creditLabel: 'Credit',
  unpaidLabel: 'Unpaid',

  // Debts Overview (Dashboard)
  debtsOverview: 'Debts Overview',
  receivablesLabel: 'Receivables',
  payablesLabel: 'Payables',
  customersOweYou: 'Customers owe you',
  youOweSuppliers: 'You owe suppliers',
  outstandingCustomerDebts: 'Outstanding Customer Debts',
  outstandingSupplierDebts: 'Outstanding Supplier Debts',
  moreItems: 'more',

  // Drilldown screens
  salesDetails: 'Sales Details',
  purchaseDetails: 'Purchase Details',
  expenseDetails: 'Expense Details',
  cashAccountTitle: 'Cash Account',
  bankAccountTitle: 'Bank Account',
  mobileMoneyAccountTitle: 'Mobile Money Account',
  openingBalance: 'Opening Balance',
  closingBalance: 'Closing Balance',
  noRecordsFound: 'No records found for this period',
  recordsLabel: 'records',
  moneyIn: 'In',
  moneyOut: 'Out',

  // Business Profile & Payment Settings
  businessProfile: 'Business Profile',
  businessAddress: 'Business Address',
  businessAddressPlaceholder: 'Street, City, Country',
  businessLogo: 'Business Logo',
  uploadLogo: 'Tap to upload logo',
  removeLogo: 'Remove',
  logoUploaded: 'Logo uploaded',
  bankDetails: 'Bank Details',
  bankName: 'Bank Name',
  accountName: 'Account Name',
  accountNumber: 'Account Number',
  mobileMoneyProvider: 'Provider (e.g. M-Pesa)',
  mobileMoneyNumber: 'Mobile Money Number',
  paymentDetails: 'Payment Details',
  phone: 'Phone',

  // Authentication
  login: 'Login',
  signup: 'Sign Up',
  logout: 'Logout',
  email: 'Email',
  emailOrPhone: 'Email or Phone',
  password: 'Password',
  fullName: 'Full Name',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  agreeToTerms: 'Please agree to the Terms & Privacy Policy to continue.',
  termsPrivacy: 'Terms & Privacy',
  termsAndPrivacy: 'Terms & Privacy Policy',
  iAgreeToThe: 'I agree to the',
  agreeAndContinue: 'Agree & Continue',
  loginToYourAccount: 'Login to your account',
  signupToGetStarted: 'Create an account to get started',
  ownerName: 'Owner Name',
  confirmPassword: 'Confirm Password',
  alreadyHaveAccount: 'Already have an account?',
  dontHaveAccount: "Don't have an account?",
  loginSuccess: 'Login successful',
  signupSuccess: 'Account created successfully',
  loginError: 'Login failed. Please check your credentials.',
  signupError: 'Signup failed. Please try again.',
  resetEmailSent: 'Password reset link sent to your email!',
  userNotFound: 'No account found with this email.',
  passwordMismatch: 'Passwords do not match',
  passwordTooShort: 'Password must be at least 8 characters',
  invalidEmail: 'Please enter a valid email',
  welcomeBack: 'Welcome Back',
  createAccount: 'Create Account',
  enterEmail: 'Enter your email',
  enterPassword: 'Enter your password',
  enterBusinessName: 'Enter your business name',
  enterOwnerName: 'Enter your name',
  professionalBusiness: 'Professional Business',
  hi: 'Hi !',
  rememberMe: 'Remember Me',
  createLabel: 'Create',
  newAccount: 'New Account',
  forgotPasswordTitle: 'Forgot',
  passwordLabel: 'Password',
  send: 'SEND',
  setNew: 'Set New',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  resetEmailSentDesc: 'Enter your new password below to reset your account.',
  passwordResetSuccess: 'Password reset successfully! Please login.',
  passwordTooShort: 'Password must be at least 6 characters.',
  resetError: 'Failed to reset password. Please try again.',
  // Appearance / themes
  appearance: 'Appearance',
  appearanceSub: 'Choose how the app looks.',
  themeVibrant: 'Vibrant',
  themeBold: 'Bold',
  themeMinimal: 'Minimal',
  themeDark: 'Dark',
  // Hero-split auth screens
  appTagline: 'Run your business smarter. Invoices, inventory, and reports in one place.',
  welcomeHeroLine: 'Welcome',
  welcomeHeroAccent: 'back.',
  signInEyebrow: 'Sign in',
  hiThere: 'Hi there,',
  loginSub: 'Enter your details to continue.',
  emailPh: 'you@example.com',
  fullNamePh: 'Your full name',
  signupHeroLine: 'Create your',
  signupHeroAccent: 'account.',
  signupEyebrow: 'Sign up',
  signupTitle: "Let's get you set up",
  signupSub: 'Just a few quick details to create your account.',
  forgotHeroLine: 'Forgot',
  forgotHeroAccent: 'password?',
  forgotHeroSub: "Enter the email you signed up with and we'll send you a secure link to reset it.",
  resetEyebrow: 'Reset',
  forgotTitle: 'Check your inbox',
  forgotSub: "We'll email you a link to set a new password.",
  setNewHeroLine: 'Set new',
  setNewHeroAccent: 'password.',
  setNewHeroSub: 'Choose a strong password to secure your account.',
  almostDone: 'Almost done',
  samePasswordError: 'Your new password must be different from your current password. Please choose a different one.',
  weakPasswordError: 'This password is too weak. Use at least 6 characters with a mix of letters and numbers.',
  resetLinkExpired: 'This reset link has expired. Please request a new one from the Forgot Password page.',
  resetLinkInvalid: 'This reset link is invalid or has already been used. Please request a new one.',
  rememberYourPassword: 'Remember your password?',
  mockEmailFrom: 'Biashara Track APP',
  mockEmailSubject: 'Password Reset Request',
  mockEmailBody: 'You requested a password reset for your Biashara Track APP account. Click the button below to set a new password.',
  mockEmailResetBtn: 'Reset My Password',
  dismissLabel: 'Dismiss',

  // Subscription
  subscription: 'Subscription',
  choosePlan: 'Choose Your Plan',
  monthly: 'Monthly',
  yearly: 'Yearly',
  monthlyPrice: '$9.99/month',
  yearlyPrice: '$99/year',
  yearlySavings: 'Save 17%',
  subscribe: 'Subscribe',
  currentPlan: 'Current Plan',
  subscriptionRequired: 'Subscription Required',
  subscriptionMessage: 'Choose a subscription plan to continue using the app',
  freeTrial: '7-day free trial',
  cancelAnytime: 'Cancel anytime',
  allFeatures: 'All features included',
  prioritySupport: 'Priority support',
  unlimitedData: 'Unlimited data storage',

  // Proforma Invoice
  proformaInvoice: 'Proforma Invoice',
  generateProforma: 'Generate Proforma Invoice',
  proformaTitle: 'PROFORMA INVOICE',
  addItem: 'Add Item',
  removeItem: 'Remove',
  lineTotal: 'Total',
  subtotal: 'Subtotal',
  discount: 'Discount (%)',
  discountAmount: 'Discount',
  grandTotal: 'Grand Total',
  notATaxInvoice: 'This is a proforma invoice only — not a tax invoice.',
  validFor: 'Valid for 30 days from date of issue.',
  proformaNo: 'Proforma No.',
  downloadProforma: 'Download Proforma (PDF)',
  customerDetails: 'Customer Details',
  itemRequired: 'Please add at least one item with product, quantity and price.',

  // Backup & Restore
  backupRestore: 'Backup & Restore Data',
  backupDesc: 'Export all your data to a file for safekeeping or to transfer to another device.',
  exportData: 'Export Data (Backup)',
  importData: 'Import Data (Restore)',
  importWarning: 'Importing will replace ALL current data. This cannot be undone.',
  importSuccess: 'Data restored successfully! The app will reload.',
  importError: 'Invalid backup file. Please select a valid Biashara Track backup.',

  // Invoice
  generateInvoice: 'Generate Invoice',
  invoiceNo: 'Invoice No.',
  billTo: 'Bill To',
  saleRecorded: 'Sale Recorded!',
  invoiceReady: 'Sale saved. Generate an invoice to share with your customer.',
  downloadInvoice: 'Download Invoice (PDF)',
  done: 'Done',
  viewInvoice: 'Invoice',

  // Manual transaction / Withdrawal form
  updateBalanceWithdraw: 'Update Balance / Withdraw',
  manualTransaction: 'Manual Transaction',
  transactionTypeLabel: 'Type',
  withdrawOption: 'Withdraw (Money Out)',
  depositOption: 'Deposit (Money In)',
  enterAmountPlaceholder: 'Enter amount',
  withdrawalDescPlaceholder: 'e.g. Personal withdrawal',
  saveTransaction: 'Save Transaction',

  // Setup menu
  notSet: 'Not set',
  noItemsYet: 'No items yet',
  addNew: 'Add New',
  productServices: 'Products / Services',
  services: 'Services',
  service: 'Service',
  itemType: 'Item Type',
  selectService: 'Select Service',
  serviceName: 'Service Name',
  addService: 'Add Service',
  editService: 'Edit Service',
  defaultPrice: 'Default Price',
  recordService: 'Record Service',
  serviceTransactions: 'Service Transactions',
  serviceRevenue: 'Service Revenue',
  serviceProfit: 'Service Profit',
  defaultCost: 'Default Cost',
  optional: 'optional',
  pleaseRegisterServices: 'Please register services first in Setup',
  businessType: 'Business Type',
  selectBusinessType: 'Choose your business type',
  serviceOnly: 'Service Only',
  productsOnly: 'Products Only',
  productsAndServices: 'Products & Services',
  serviceOnlyDesc: 'You provide services (consulting, repair, etc.)',
  productsOnlyDesc: 'You sell physical or digital products',
  productsAndServicesDesc: 'You sell both products and offer services',
  paymentAccounts: 'Payment Accounts',
  addPaymentAccount: 'Add Account',
  editPaymentAccount: 'Edit Account',
  noPaymentAccountsYet: 'No payment accounts added yet',
  bankAccount: 'Bank Account',
  mobileMoneyAccount: 'Mobile Money',
  accountType: 'Account Type',
  networkName: 'Network / Provider (e.g. M-Pesa)',
  phoneNumberLabel: 'Phone Number',

  // Hardcoded string keys (Setup subtitles, placeholders, contact labels)
  startHere: 'Business Details',
  businessNameSub: 'This name appears on your invoices and reports.',
  businessAddressSub: 'Shown on invoices below your business name.',
  bankNamePlaceholder: 'e.g. CRDB, NMB, Equity',
  accountHolderPlaceholder: 'Account holder name',
  accountNumberPlaceholder: 'Account number',
  networkNamePlaceholder: 'e.g. M-Pesa, Tigo Pesa, Airtel',
  phonePlaceholder: 'e.g. 0712 345 678',
  contactEmailLabel: 'Email',
  contactPhoneLabel: 'Phone',
  contactWebsiteLabel: 'Website',
  itemSingular: 'item',
  itemPlural: 'items',
  accountSingular: 'account',
  accountPlural: 'accounts',
  accountNameRequired: 'Account name is required',
  bankNameRequired: 'Bank name is required',
  networkNameRequired: 'Network name is required',

  // Compliance & Tax section
  complianceTax: 'Compliance & Tax',
  complianceTaxDesc: 'These details appear on your invoices and receipts for compliance purposes.',
  tinLabel: 'TIN (Tax Identification Number)',
  vrnLabel: 'VRN (VAT Registration Number)',
  businessRegLabel: 'Business Registration Number',
  tradeLicenseLabel: 'Trade License Number',
  complianceOptionalNote: 'These sections are optional. Fill these in if your business is registered with TRA or has a business license.',

  // Currency setup
  chooseCurrency: 'Choose Currency',
  currencySubLabel: 'Used across all reports and invoices',

  // Settings screen
  subscriptionStatus: 'Subscription Status',
  activePlan: 'Active',
  expiredLabel: 'Expired',
  expiresOn: 'Expires',
  trialPlan: 'Free Trial',
  planMonthly: 'Monthly Plan',
  planYearly: 'Yearly Plan',
  choosePlanTitle: 'Choose Your Plan',
  selectThisPlan: 'Select This Plan',
  popular: 'POPULAR',
  currentPlanBadge: 'Current',
  perMonth: '/month',
  freeTrialDesc: '7-day free trial to explore all features',
  fkStarter: 'FK Starter',
  fkStarterPrice: 'TZS 10,000',
  fkStarterDuration: '1 Month',
  fkPlus: 'FK Plus',
  fkPlusPrice: 'TZS 28,000',
  fkPlusDuration: '3 Months',
  fkSmart: 'FK Smart',
  fkSmartPrice: 'TZS 50,000',
  fkSmartDuration: '6 Months',
  fkPremium: 'FK Premium',
  fkPremiumPrice: 'TZS 90,000',
  fkPremiumDuration: '12 Months',
  privacyPolicy: 'Privacy Policy',
  contactUs: 'Contact Us',
  sessionExpiredTitle: 'Session Expired',
  sessionExpiredDesc: 'Your session has expired. Please log in again to continue syncing your data. Your local data is safe.',
  logInAgain: 'Log In Again',
  exportAllData: 'Export All Data',
  exportAllDataDesc: 'Download as Excel (.xlsx)',
  synced: 'Synced',
  syncing: 'Syncing…',
  offline: 'Offline',
  offlineMode: 'Offline — data saved locally',
  deleteAccount: 'Delete Account',
  deleteAccountWarning: 'This will permanently delete your account and all your business data from the cloud. This action cannot be undone.',
  deleteAccountNote: 'Your data will be erased within 30 days per our Privacy Policy.',
  typeDeleteToConfirm: 'Type DELETE to confirm:',
  deleting: 'Deleting…',
  contactEmail: 'hesabusolutionstz@gmail.com',
  contactPhone: '+255 680072640',
  contactWebsite: 'www.faidaapp.com',
  privacyPolicyText: 'Last updated: May 2025\n\nBiashara Track ("we", "our", or "us") is operated by Hesabu Solutions. This Privacy Policy explains how we collect, use, store, and protect your information when you use the Biashara Track business management app.\n\n1. INFORMATION WE COLLECT\nWe collect: your email address and business name (at registration); business data you enter (sales, purchases, expenses, inventory, customers, suppliers); and basic device/usage information for app performance.\n\n2. HOW YOUR DATA IS STORED\nYour data is stored in two places: (a) on your device (local storage) for offline access and fast performance, and (b) on secure cloud servers provided by Supabase (supabase.com), a third-party cloud database platform. Cloud sync keeps your data backed up and accessible across devices. Supabase stores data in secure, encrypted facilities.\n\n3. HOW WE USE YOUR DATA\nWe use your data to: provide and operate the Biashara Track app; sync your data across devices; send important account and subscription notifications; and improve app performance and fix issues. We do not use your data for advertising or marketing purposes.\n\n4. THIRD-PARTY SERVICES\nWe use the following third-party services:\n- Supabase (supabase.com): secure cloud data storage and user authentication\n- ClickPesa: payment processing for subscriptions\n\nThese providers have their own privacy policies and are contractually required to protect your data.\n\n5. DATA SHARING\nWe do not sell, rent, or share your personal or business data with any third parties for commercial purposes. Data may be disclosed if required by law or to protect the safety of users.\n\n6. YOUR RIGHTS\nYou have the right to: access the data we hold about you; export all your business data (available in Settings); request deletion of your account and all associated data; and correct inaccurate information.\n\n7. DATA RETENTION\nYour data is retained as long as your account is active. When you delete your account, all cloud data is permanently deleted within 30 days.\n\n8. SECURITY\nWe use encryption in transit (HTTPS/TLS) and at rest (Supabase AES-256). However, no system is 100% secure — please keep your login credentials private.\n\n9. CONTACT\nFor privacy questions or data requests, contact us at: hesabusolutionstz@gmail.com',

  // Subscription Payment Flow
  daysLeft: 'days left',
  subExpiredTitle: 'Your subscription has expired',
  subExpiredDesc: 'Renew your subscription to continue using Biashara Track APP. Choose a plan below to get started.',
  upgradeOrRenew: 'Upgrade or Renew',
  payForPlan: 'Pay for',
  mobileMoneyPhone: 'Mobile Money Number',
  invalidPhone: 'Enter a valid phone number',
  payNow: 'Pay Now',
  creatingPayment: 'Creating payment...',
  waitingForPayment: 'Waiting for payment...',
  verifyingPayment: 'Verifying payment...',
  checkYourPhone: 'Check your phone for the payment prompt',
  pleaseWait: 'Please wait',
  paymentSuccess: 'Payment Successful!',
  subscriptionActivated: 'Your subscription has been activated.',
  paymentFailed: 'Payment Failed',
  tryAgain: 'Try Again',
  accessAllFeatures: 'Access to all features',

  // Quick Reports (Dashboard)
  quickReports: 'Quick Reports',
  customerStatement: 'Customer Statement',
  agingReport: 'Aging Report',
  receivablesAgingReport: 'Receivables Aging Report',
  dailySummary: 'Daily Summary',
  stockValuation: 'Stock Valuation',
  whtReport: 'WHT Report',
  whtReportFull: 'WHT Report (Withholding Tax)',

  // Customer Statement labels
  allCustomersOption: 'All Customers',
  totalBilled: 'Total Billed',
  totalPaid: 'Total Paid',
  balanceOwed: 'Balance Owed',
  noTransactionsFound: 'No transactions found',

  // Aging Report labels
  totalOutstanding: 'Total Outstanding',
  acrossInvoices: 'invoice',
  acrossInvoicesPlural: 'invoices',
  noOutstandingInvoices: '★ No outstanding invoices!',

  // Daily Summary labels
  salesRevenue: 'Sales Revenue',
  grossProfit: 'Gross Profit',
  transactionsLabel: 'Transactions',
  noTransactionsDate: 'No transactions for this date.',

  // Daily Summary transaction type badges
  saleLabel: 'Sale',
  buyLabel: 'Buy',
  expLabel: 'Exp',

  // Stock Valuation labels
  totalCostValue: 'Total Cost Value',
  totalSellingValue: 'Total Selling Value',
  costPerUnit: 'Cost/Unit',
  sellPerUnit: 'Sell/Unit',
  costValue: 'Cost Value',
  sellValue: 'Sell Value',
  noProductsFound: 'No products found',

  // WHT Report labels
  totalWHTCollected: 'Total WHT Collected',
  noWHTTransactions: 'No WHT transactions in this period',
  saleAmt: 'Sale Amt',
  whtRate: 'WHT Rate',
  whtAmt: 'WHT Amt',
  whtFromSales: 'WHT Collected from Clients (Sales)',
  whtFromPurchases: 'WHT Paid to Suppliers (Purchases)',
  purchaseAmt: 'Purchase Amt',
  totalWHTCharged: 'Total WHT Paid',

  // VAT Report labels
  vatReport: 'VAT Report',
  vatReportFull: 'VAT Report (Value Added Tax)',
  totalVATFromSales: 'Total VAT (Sales)',
  totalVATFromPurchases: 'Total VAT (Purchases)',
  noVATTransactions: 'No VAT transactions in this period',
  vatFromSales: 'VAT Collected (Sales)',
  vatFromPurchases: 'VAT Paid (Purchases)',
  vatRate: 'VAT Rate',
  vatAmt: 'VAT Amt',

  // Common report labels
  fromLabel: 'From',
  toLabel: 'To',
  invoice: 'Invoice',
  item: 'Item',

  // Stock Adjustment
  stockAdjustment: 'Stock Adjustment',

  // Tax labels
  addTax: '+ Add Tax',
  vatOption: 'VAT (Value Added Tax)',
  withholdingOption: 'Withholding Tax',
  noTaxesAdded: 'No taxes added. Click "Add Tax" to include VAT 18% or custom withholding tax.',

  // User Manual
  userManual: 'User Manual',
  userManualSub: 'App usage guide (PDF)',

  // FAQ
  faq: 'FAQ',

  // Returns
  salesReturns: 'Sales Returns',
  purchaseReturns: 'Purchase Returns',

  // Missing keys (used in App.js with || fallbacks)
  download: 'Download',
  search: 'Search',
  newestFirst: 'Newest First',
  oldestFirst: 'Oldest First',
  highestAmount: 'Highest Amount',
  lowestAmount: 'Lowest Amount',
  noResults: 'No Results',
  invoiceItems: 'Invoice Items',
  viewItems: 'View Items',
  sale: 'Sale',
  purchase: 'Purchase',
  expense: 'Expense',
  unit: 'Unit of Measure',
  buyingPrice: 'Buying Price',
  yesterday: 'Yesterday',
  lastWeek: 'Last Week',
  lastMonth: 'Last Month',
  lastYear: 'Last Year',

  // VAT & P&L
  vatRateSetting: 'Default VAT Rate',
  profitAndLoss: 'Profit & Loss',

  // Ledger
  ledger: 'Ledger',
  customerLedger: 'Customer Ledger',
  supplierLedger: 'Supplier Ledger',
  outstanding: 'OUTSTANDING',
  owedToSupplier: 'YOU OWE',
  markPaid: 'Mark Paid',
  noTransactionsYet: 'No transactions yet',
  totalTransactions: 'TRANSACTIONS',
  // Accessibility
  skipToContent: 'Skip to main content',
  mainNavigation: 'Main navigation',
  loadingApp: 'Loading Biashara Track...',
  loading: 'Loading',
};

export default en;
